import React, { useState } from "react";

const InputField = ({
  label,
  name,
  value,
  onChange,
  type = "text",
  placeholder = "",
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="relative mb-6">
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(!!value)} // Keep label floated if there's a value
        // placeholder={placeholder}
        className={`peer w-full border border-[#CFCFCF] rounded-lg py-3 px-4 text-sm bg-[#F7F7F7] outline-none focus:ring-2 focus:ring-blue-500 ${
          isFocused || value ? "pt-5" : ""
        }`}
      />
      <label
        className={`absolute left-4 top-3 text-sm text-gray-400 transition-all transform ${
          isFocused || value
            ? "-translate-y-3 scale-100 text-blue-500"
            : "translate-y-0 scale-100"
        }`}
      >
        {label}
      </label>
    </div>
  );
};

export default InputField;
